import isUndefined from 'lodash/isUndefined';
import React, { memo } from 'react';

import {
  getRichLevel,
  getStarLevel,
  getShinningStar,
  getRichInfo,
  getStarInfo,
  getCoinLevel,
  getCoinInfo,
  getNobilityInfo,
} from 'lib/level';

// weekSpend
// bean 主播
// coin 用户
// richLevel
// starLevel

export const IconLevel = memo((props) => {
  const { richLevel, starLevel, bean, coin, weekSpend } = props;
  if (!isUndefined(richLevel)) {
    const { level, name } = getRichInfo(richLevel);
    return <i className={`richLV r_${level}`} title={name} />;
  }
  if (!isUndefined(starLevel)) {
    const { level, name } = getStarInfo(starLevel);
    return <i className={`starLV s_${level}`} title={name} />;
  }

  if (!isUndefined(bean)) {
    const { level, name } = getStarLevel(bean);
    return <i className={`starLV s_${level}`} title={name} />;
  }
  if (!isUndefined(coin)) {
    const { level, name } = getRichLevel(coin);
    // if (weekSpend) {
    //   let shinningStar = getShinningStar(weekSpend);
    //   return (
    //     <span className={'richLV r_' + level} title={name}>
    //       {shinningStar.isShinning && (
    //         <i className={shinningStar.icon} title={shinningStar.title} />
    //       )}
    //     </span>
    //   );
    // } else {
    return <i className={`richLV r_${level}`} title={name}></i>;
    // }
  }

  return null;
});

export const RichLevel = ({ coin, level }) => {
  return <IconLevel richLevel={level} coin={coin} />;
};

export const StarLevel = ({ bean, level }) => {
  return <IconLevel starLevel={level} bean={bean} />;
};

// 数字等级取消了
export const CoinLevel = RichLevel;

// export const CoinLevel = ({ coin = 0, level = 0, weekSpend = 0 }) => {
//   let coinData = level ? getCoinInfo(level) : getCoinLevel(coin);
//   const getShinningStarIcon = () => {
//     if (weekSpend) {
//       let shinningStar = getShinningStar(weekSpend);
//       if (shinningStar.isShinning) {
//         return <i className={shinningStar.icon} title={shinningStar.title} />;
//       }
//     }
//     return null;
//   };
//
//   if (coinData) {
//     return (
//       <span
//         className={'coinLV c_' + coinData.level + ' cr_' + coinData.richLevel}
//         title={coinData.name}>
//         {getShinningStarIcon()}
//       </span>
//     );
//   }
//
//   return null;
// };

export const NobleLevel = ({ level }) => {
  const { name } = getNobilityInfo(parseInt(level, 10));
  return <span className={`nobilityLV n-${level}`} title={name}></span>;
};

export const SuperNobleLevel = () => {
  return <span className="superNobilityLV"></span>;
};

export const StarVipLevel = ({ level }) => {
  const name = level === 1 ? 'Vip' : 'SVip';
  return <span className={`starVipLV svl-${level}`} title={name}></span>;
};

// 用户会员充值等级
export const PayLevel = ({ level, forceShow = false }) => {
  // 黑铁不显示
  // if (!level && !forceShow) {
  //   return null;
  // }

  const name =
    ['黑铁', '青铜', '白银', '黄金', '铂金', '黑金', '钻石V1', '钻石V2', '钻石V3', '钻石V4'][
      level
    ] || '-';

  return <span title={name} className={`payLevel payLevel${level}`}></span>;
};

// 闪耀财星
export const WeekSpendLevel = ({ weekSpend, type }) => {
  if (type) {
    return <span className={`weekSpendLevel weekSpendLevel${type}`} title={`闪耀${type}星`}></span>;
  }

  const data = getShinningStar(weekSpend);
  if (!data.type) {
    return null;
  }
  return <span className={`weekSpendLevel weekSpendLevel${data.type}`} title={data.title}></span>;
};

//
/**
 * 主播认证
 * @param level 等级 [0-5]
 * @param type  认证类型 [dancer, singer, dating, appearance]   DANCER 舞者，SINGER 歌手，APPEARANCE 颜值，DATING 交友
 * @returns {JSX.Element}
 * @constructor
 */
export const StarCertLevel = ({ level, type }) => {
  return (
    <span className={`iden-icon-v2 iden-cert iden-cert-${type.toLowerCase()}-${level}`}></span>
  );
};

/**
 * 幸运大咖
 * @returns {JSX.Element}
 * @constructor
 */

export const LuckyStar = (props) => {
  return <span className="iden-icon-v2 iden-lucky-star"></span>;
};

// 1: 普通新用户, 2: 活跃新用户, 3: 潜力新用户
export const NewUserLevel = ({ level }) => {
  if (level === 1) {
    return <span className="iden-icon-v2 iden-new-v2"></span>;
  }
  if (level > 1) {
    return <span className={`iden-icon-v2 iden-new-user-${level}`}></span>;
  }
  return null;
};

// 主播信用等级
// （绿、黄、红），依次对应70分以上、1~69分、0分
export const CreditLevel = ({ score, ...rest }) => {
  let level = 'low';
  if (score > 70) {
    level = 'high';
  } else if (score > 1) {
    level = 'middle';
  }
  return (
    <div className={`iden-icon-v2 creditLevel credit-${level}`} {...rest}>
      <span className="credit-icon"></span>
      <span className="credit-text">信用分{score}</span>
    </div>
  );
};
